import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import {EVENT_SERVICE} from "../EndPoints";

export const GetEventFilters = createAsyncThunk('employeeEvents/getEventFilters', async () => {
    const response = await apiInstance
        .get('assets-service/event/get-filters')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllVisitorTypes = createAsyncThunk('employeeEvents/getAllVisitorTypes', async () => {
    const response = await apiInstance
        .get('visitor-types-service/get-all-active-visitor-types')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetVisitorTypeByID = createAsyncThunk('employeeEvents/getVisitorTypeByID', async (id) => {
    const response = await apiInstance
        .get(`visitor-types-service/get-by-id/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getAllEmployees = createAsyncThunk('employeeEvents/allEmployees', async () => {
    const response = await apiInstance
        .get('employee-service/get-all/only-user-data')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const searchByEmail = createAsyncThunk('employeeEvents/searchByEmail', async (email) => {
    const response = await apiInstance
        .get(`user-service/get-by-email/${email}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const searchByPhone = createAsyncThunk('employeeEvents/searchByPhone', async (phone) => {
    const response = await apiInstance
        .get(`user-service/get-by-phone-number/${phone}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const createNormalEvent = createAsyncThunk('employeeEvents/createNormalEvent', async (body) => {
    const response = await apiInstance
        .post('event-service/v1/create', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getEventDetail = createAsyncThunk('employeeEvents/getEventDetail', async (eventId) => {
    const response = await apiInstance
        .get(`event-service/v1/get-by-id/${eventId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const deleteUserInvitation = createAsyncThunk('employeeEvents/deleteUserInvitation', async (invitId) => {
    const response = await apiInstance
        .delete(`event-service/delete-user-invitation-by-invitation-id/${invitId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const cancelEvent = createAsyncThunk('employeeEvents/cancelEvent', async (id) => {
    const response = await apiInstance
        .put(`event-service/cancel-event/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const cancelEventByList = createAsyncThunk('employeeEvents/cancelEventByList', async (params) => {
    const response = await apiInstance
        .put(`event-service/cancel-event/by-list`,params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const companyRestrictions = createAsyncThunk('employeeEvents/companyRestrictions', async (companyId) => {
    const response = await apiInstanceV2
        .get('event-service/restriction/get')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getAllVehiclesData = createAsyncThunk('employeeEvents/getAllVehiclesData', async () => {
    const response = await apiInstance
        .get('vehicle-company-service/get-all-only-vehicle-data/by-company-id')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const preRegisterUser = createAsyncThunk('employeeEvents/preRegisterUser', async (body) => {
    const response = await apiInstance
        .post('authentication-service/pre-register-user', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const deleteEvents = createAsyncThunk('employeeEvents/deleteEvent', async (body) => {
    const response = await apiInstance
        .post(`event-service/delete-by-ids`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const validateEvent = createAsyncThunk('employeeEvents/validateEvent', async ({ id, option }) => {
    const response = await apiInstance
        .put(`event-service/validate-event/${id}/validation/${option}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const deleteUserInvitationByIds = createAsyncThunk(
    'employeeEvents/deleteUserInvitationByIds',
    async ({ id, body }) => {
        const response = await apiInstance
            .post(`event-service/delete-user-invitation-by-user-list/by-event-id/${id}`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
///event-service/v1/reservation/get-free-schedules/by-zone
export const GetFreeShedules = createAsyncThunk('employeeEvents/getFreeShedules', async ( body ) => {
    const response = await apiInstance
        .post('event-service/v1/reservation/get-free-schedules/by-zone', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GetEventSetting = createAsyncThunk('employeeEvents/getEventSetting', async (body) => {
    const response = await apiInstance
        .get('event-service/setting/get', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const UpdateEventSetting = createAsyncThunk('employeeEvents/UpdateEventSetting', async (body) => {
    const response = await apiInstance
        .put('event-service/setting/update', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const CreateFileEventSetting = createAsyncThunk('employeeEvents/CreateFileEventSetting', async (body) => {
    const response = await apiInstance
        .post(`${EVENT_SERVICE.fileCreate}`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DeleteFileEventSetting = createAsyncThunk('employeeEvents/DeleteFileEventSetting', async (body) => {
    const response = await apiInstance
        .post(`${EVENT_SERVICE.fileDeleteByIds}`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});




export const GetUserInvitations = createAsyncThunk('employeeEvents/getUserInvitations', async (params) => {
    const response = await apiInstance
        .get(`event-service/v1/web-app/get-all-user-invitations/${params.id}/${params.userTypeId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GroupInvitationsByEventId = createAsyncThunk('employeeEvents/groupInvitationsByEventId', async (id) => {
    const response = await apiInstance
        .get(`event-service/v1/web-app/count-user-invitations/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetEventApprovalComments = createAsyncThunk('employeeEvents/getEventApprovalComments', async (id) => {
    const response = await apiInstance
        .get(`event-service/v1/event-approval/comments/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const CreateUserInvitationEvent = createAsyncThunk('employeeEvents/createUserInvitationEvent', async (body) => {
    const response = await apiInstance
        .post('event-service/v1/create-user-invitations', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
